"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var FinanceReconciliationsListCtl = /** @class */ (function (_super) {
    __extends(FinanceReconciliationsListCtl, _super);
    function FinanceReconciliationsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_is_reset_negative_balances = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_reset_negative_balances; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_pprogram_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.pprogram_id; });
        _this.dk_pprogram_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.pprogram_title; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_partners_count_inside = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partners_count_inside; });
        _this.dk_total_amount_by_players = UIUtils_1.UIUtils.IProp2Str(function (o) { o.total_amount_by_players; });
        _this.dk_total_amount_by_subagents = UIUtils_1.UIUtils.IProp2Str(function (o) { o.total_amount_by_subagents; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this._errDialog = errDialog;
        return _this;
    }
    FinanceReconciliationsListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    FinanceReconciliationsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    FinanceReconciliationsListCtl.prototype.LoadRangeDataByBrandsList = function (data, onDone) {
        var _this = this;
        webAApi_1.ListPartnersReconciliationsByDateRangeGet.exec({
            all_brands: data.allBrands,
            brand_id_list: data.brands,
            offset: data.Offset,
            limit: data.Limit,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            from_hour: data.from_hour,
            from_minute: data.from_minute,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            to_hour: data.to_hour,
            to_minute: data.to_minute
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    pprogram_id: resp.list[i].pprogram_id,
                    pprogram_title: resp.list[i].pprogram_title,
                    is_reset_negative_balances: resp.list[i].is_reset_negative_balances,
                    description: resp.list[i].description,
                    partners_count_inside: resp.list[i].partners_count_inside,
                    total_amount_by_players: resp.list[i].total_amount_by_players,
                    total_amount_by_subagents: resp.list[i].total_amount_by_subagents,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    FinanceReconciliationsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPartnersReconciliation.exec({
            data: {
                title: data.title,
                pprogram_id: data.pprogram_id,
                brand_id: data.brand_id,
                description: data.description,
                is_reset_negative_balances: data.is_reset_negative_balances
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                brand_id: resp.brand_id,
                brand_title: resp.brand_title,
                pprogram_id: resp.pprogram_id,
                pprogram_title: resp.pprogram_title,
                title: data.title,
                description: data.description,
                is_reset_negative_balances: data.is_reset_negative_balances,
                partners_count_inside: 0,
                total_amount_by_players: 0,
                total_amount_by_subagents: 0,
                date_added: moment(resp.date_added_uts_ms).utc(false),
                date_changed: moment(resp.date_added_uts_ms).utc(false),
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    FinanceReconciliationsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditPartnerReconciliation.exec({
                data: {
                    usr_partner_reconciliation_id: data.key,
                    title: data.title,
                    description: data.description,
                    is_reset_negative_balances: data.is_reset_negative_balances
                }
            }, function (resp) {
                _tmp.title = data.title;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.description = data.description;
                _tmp.is_reset_negative_balances = data.is_reset_negative_balances;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    FinanceReconciliationsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    FinanceReconciliationsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletePartnerReconciliation.exec({
                data: {
                    usr_partner_reconciliation_id: key
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    FinanceReconciliationsListCtl.prototype.DoClearPartners = function (usrPartnerReconciliationId, onDone) {
        var _this = this;
        webAApi_1.DoClearReconciliationPartnersByReconciliationId.exec({
            data: {
                usr_partner_reconciliation_id: usrPartnerReconciliationId,
            }
        }, function (resp) {
            _this.Update();
            if (onDone) {
                onDone(resp.affected_count);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    FinanceReconciliationsListCtl.prototype.DoFillPartners = function (usrPartnerReconciliationId, onDone) {
        var _this = this;
        webAApi_1.DoFillReconciliationPartnersByReconciliationId.exec({
            data: {
                usr_partner_reconciliation_id: usrPartnerReconciliationId,
            }
        }, function (resp) {
            _this.Update();
            if (onDone) {
                onDone(resp.added_count);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return FinanceReconciliationsListCtl;
}(BaseController_1.BaseController));
exports.FinanceReconciliationsListCtl = FinanceReconciliationsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_reconciliations/ctl/FinanceReconciliationsListCtl.ts
// module id = 1045
// module chunks = 0